import { render, staticRenderFns } from "./SdGeometryEditor.vue?vue&type=template&id=3c502fd4&scoped=true"
import script from "./SdGeometryEditor.vue?vue&type=script&lang=js"
export * from "./SdGeometryEditor.vue?vue&type=script&lang=js"
import style0 from "./SdGeometryEditor.vue?vue&type=style&index=0&id=3c502fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c502fd4",
  null
  
)

export default component.exports